import axios from '../axios'

export const selectPage = (data) => {
    return axios({
        url: '/admin/platformCategory/selectPage',
        method: 'post',
        data
    })
}
export const insert = (data) => {
    return axios({
        url: '/admin/platformCategory/insert',
        method: 'post',
        data
    })
}
export const update = (data) => {
    return axios({
        url: '/admin/platformCategory/update',
        method: 'post',
        data
    })
}

export const batchEnable = (data) => {
    return axios({
        url: '/admin/platformCategory/batchEnable',
        method: 'post',
        data
    })
}

export const batchDisabled = (data) => {
    return axios({
        url: '/admin/platformCategory/batchDisabled',
        method: 'post',
        data
    })
}

export const batchDelete = (data) => {
    return axios({
        url: '/admin/platformCategory/batchDelete',
        method: 'post',
        data
    })
}

export const initCreate = (data) => {
    return axios({
        url: '/admin/platformCategory/initCreate',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/platformCategory.js